import { Box, Button, Chip } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../../shared/components/variables';

export const FilterChip = styled(Chip)`
  && {
    padding: 1rem 0.5rem;
    border-radius: 1.5rem;
    color: ${colorPalette.navy500};
    background-color: ${colorPalette.white};
    border: 1px solid var(--primary-outlineBorder, ${colorPalette.navy750});
    .MuiSvgIcon-root:first-of-type:not(:only-of-type) {
      width: 1.2375rem;
      height: 1.2375rem;
      padding: 4px;
      border-radius: 50%;
      background-color: ${colorTokens.chip.dark};
      color: ${colorTokens.text.contrast};
    }

    &.sort {
      .MuiSvgIcon-root:first-of-type {
        width: 2rem;
        height: 2rem;
        background-color: transparent;
        color: ${colorPalette.neutral200};
      }
    }

    &.status-open {
      background-color: ${colorPalette.red975};
      color: ${colorPalette.neutral200};
      border: 1px solid ${colorTokens.error.outlineBorder};
      .MuiSvgIcon-root:first-of-type {
        width: 2rem;
        height: 2rem;
        background-color: ${colorPalette.red975};
        color: ${colorPalette.neutral200};
      }
    }

    &.status-resolved {
      background-color: ${colorPalette.green975};
      color: ${colorPalette.neutral200};
      border: 1px solid ${colorTokens.success.outlineBorder};
      .MuiSvgIcon-root:first-of-type {
        width: 2rem;
        height: 2rem;
        background-color: ${colorPalette.green975};
        color: ${colorPalette.neutral200};
      }
    }

    .filled {
      width: 23px;
      height: 23px;
      padding: 4px;
      border-radius: 50%;
      background-color: ${colorTokens.chip.dark};
      color: ${colorTokens.text.contrast};
    }
  }
`;

export const PriorityIcon = styled(Box)`
  border-radius: 3.3rem;
  display: flex;
  width: 1.4375rem;
  height: 1.4375rem;
  justify-content: center;
  align-items: center;
  gap: 0.51563rem;

  p {
    text-align: center;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.125rem; /* 150% */
    letter-spacing: 0.025rem;
  }

  &.urgent {
    background-color: ${colorPalette.red500};
    color: ${colorPalette.white};
    p {
      color: ${colorPalette.white};
    }
  }
  &.high {
    background-color: ${colorPalette.red975};
    border: 0.825px solid ${colorTokens.error.outlineBorder};
  }
  &.medium {
    background-color: ${colorPalette.yellow950};
    border: 0.825px solid ${colorPalette.yellow300};
  }
  &.low {
    background-color: ${colorPalette.white};
    border: 0.825px solid ${colorPalette.neutral550};
  }
`;

export const StyledClearButton = styled(Button)`
  color: ${colorPalette.navy650};
  &:hover {
    background-color: none;
  }
`;
